import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { insertRow } from '@/api/supabaseClient';

const VISITOR_STORAGE_KEY = 'cdi-anonymous-visitor-id';

function anonymousVisitorId() {
  try {
    const stored = window.localStorage.getItem(VISITOR_STORAGE_KEY);
    if (stored && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(stored)) return stored;
    const identifier = window.crypto?.randomUUID?.();
    if (!identifier) return null;
    window.localStorage.setItem(VISITOR_STORAGE_KEY, identifier);
    return identifier;
  } catch {
    return null;
  }
}

export default function PageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname || pathname.startsWith('/admin') || pathname.startsWith('/intra')) return;
    const send = () => {
      try {
        const visitanteId = anonymousVisitorId();
        if (!visitanteId) return;
        void insertRow('page_views', { pagina: pathname, visitante_id: visitanteId }).catch(() => {});
      } catch {
        // Analytics must never interrupt public navigation.
      }
    };
    const timer = window.setTimeout(send, 5_000);
    return () => window.clearTimeout(timer);
  }, [pathname]);

  return null;
}
